import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf enum devices.v1.DeviceType
 */
export var DeviceType;
(function (DeviceType) {
    /**
     * @generated from protobuf enum value: DEVICE_TYPE_UNSPECIFIED = 0;
     */
    DeviceType[DeviceType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: DEVICE_TYPE_STATION = 1;
     */
    DeviceType[DeviceType["STATION"] = 1] = "STATION";
    /**
     * @generated from protobuf enum value: DEVICE_TYPE_EVSE = 2;
     */
    DeviceType[DeviceType["EVSE"] = 2] = "EVSE";
    /**
     * @generated from protobuf enum value: DEVICE_TYPE_CONNECTOR = 3;
     */
    DeviceType[DeviceType["CONNECTOR"] = 3] = "CONNECTOR";
    /**
     * @generated from protobuf enum value: DEVICE_TYPE_STATIONARY_BATTERY = 4;
     */
    DeviceType[DeviceType["STATIONARY_BATTERY"] = 4] = "STATIONARY_BATTERY";
    /**
     * @generated from protobuf enum value: DEVICE_TYPE_SOLAR_PANEL = 5;
     */
    DeviceType[DeviceType["SOLAR_PANEL"] = 5] = "SOLAR_PANEL";
    /**
     * @generated from protobuf enum value: DEVICE_TYPE_SITE = 6;
     */
    DeviceType[DeviceType["SITE"] = 6] = "SITE";
    /**
     * @generated from protobuf enum value: DEVICE_TYPE_SITE_CONTROLLER = 7;
     */
    DeviceType[DeviceType["SITE_CONTROLLER"] = 7] = "SITE_CONTROLLER";
    /**
     * @generated from protobuf enum value: DEVICE_TYPE_METER = 8;
     */
    DeviceType[DeviceType["METER"] = 8] = "METER";
    /**
     * @generated from protobuf enum value: DEVICE_TYPE_INVERTER = 9;
     */
    DeviceType[DeviceType["INVERTER"] = 9] = "INVERTER";
    /**
     * @generated from protobuf enum value: DEVICE_TYPE_GATEWAY = 10;
     */
    DeviceType[DeviceType["GATEWAY"] = 10] = "GATEWAY";
    /**
     * @generated from protobuf enum value: DEVICE_TYPE_GENERATOR = 11;
     */
    DeviceType[DeviceType["GENERATOR"] = 11] = "GENERATOR";
    /**
     * @generated from protobuf enum value: DEVICE_TYPE_LOAD = 12;
     */
    DeviceType[DeviceType["LOAD"] = 12] = "LOAD";
    /**
     * @generated from protobuf enum value: DEVICE_TYPE_ESS = 13;
     */
    DeviceType[DeviceType["ESS"] = 13] = "ESS";
})(DeviceType || (DeviceType = {}));
/**
 * @generated from protobuf enum devices.v1.DeploymentStatus
 */
export var DeploymentStatus;
(function (DeploymentStatus) {
    /**
     * @generated from protobuf enum value: DEPLOYMENT_STATUS_UNSPECIFIED = 0;
     */
    DeploymentStatus[DeploymentStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: DEPLOYMENT_STATUS_PLANNED = 1;
     */
    DeploymentStatus[DeploymentStatus["PLANNED"] = 1] = "PLANNED";
    /**
     * @generated from protobuf enum value: DEPLOYMENT_STATUS_IN_PROGRESS = 2;
     */
    DeploymentStatus[DeploymentStatus["IN_PROGRESS"] = 2] = "IN_PROGRESS";
    /**
     * @generated from protobuf enum value: DEPLOYMENT_STATUS_DEPLOYED = 3;
     */
    DeploymentStatus[DeploymentStatus["DEPLOYED"] = 3] = "DEPLOYED";
    /**
     * @generated from protobuf enum value: DEPLOYMENT_STATUS_MAINTENANCE = 4;
     */
    DeploymentStatus[DeploymentStatus["MAINTENANCE"] = 4] = "MAINTENANCE";
    /**
     * @generated from protobuf enum value: DEPLOYMENT_STATUS_DECOMMISSIONED = 5;
     */
    DeploymentStatus[DeploymentStatus["DECOMMISSIONED"] = 5] = "DECOMMISSIONED";
})(DeploymentStatus || (DeploymentStatus = {}));
/**
 * @generated from protobuf enum devices.v1.CriticalityLevel
 */
export var CriticalityLevel;
(function (CriticalityLevel) {
    /**
     * @generated from protobuf enum value: CRITICALITY_LEVEL_UNSPECIFIED = 0;
     */
    CriticalityLevel[CriticalityLevel["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: CRITICALITY_LEVEL_LOW = 1;
     */
    CriticalityLevel[CriticalityLevel["LOW"] = 1] = "LOW";
    /**
     * @generated from protobuf enum value: CRITICALITY_LEVEL_MEDIUM = 2;
     */
    CriticalityLevel[CriticalityLevel["MEDIUM"] = 2] = "MEDIUM";
    /**
     * @generated from protobuf enum value: CRITICALITY_LEVEL_HIGH = 3;
     */
    CriticalityLevel[CriticalityLevel["HIGH"] = 3] = "HIGH";
    /**
     * @generated from protobuf enum value: CRITICALITY_LEVEL_CRITICAL = 4;
     */
    CriticalityLevel[CriticalityLevel["CRITICAL"] = 4] = "CRITICAL";
})(CriticalityLevel || (CriticalityLevel = {}));
/**
 * @generated from protobuf enum devices.v1.ChargingRateUnit
 */
export var ChargingRateUnit;
(function (ChargingRateUnit) {
    /**
     * @generated from protobuf enum value: CHARGING_RATE_UNIT_UNSPECIFIED = 0;
     */
    ChargingRateUnit[ChargingRateUnit["CHARGING_RATE_UNIT_UNSPECIFIED"] = 0] = "CHARGING_RATE_UNIT_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: CHARGING_RATE_UNIT_KW = 1;
     */
    ChargingRateUnit[ChargingRateUnit["CHARGING_RATE_UNIT_KW"] = 1] = "CHARGING_RATE_UNIT_KW";
    /**
     * @generated from protobuf enum value: CHARGING_RATE_UNIT_A = 2;
     */
    ChargingRateUnit[ChargingRateUnit["CHARGING_RATE_UNIT_A"] = 2] = "CHARGING_RATE_UNIT_A";
})(ChargingRateUnit || (ChargingRateUnit = {}));
/**
 * @generated from protobuf enum devices.v1.CurrentType
 */
export var CurrentType;
(function (CurrentType) {
    /**
     * @generated from protobuf enum value: CURRENT_TYPE_UNSPECIFIED = 0;
     */
    CurrentType[CurrentType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: CURRENT_TYPE_AC = 1;
     */
    CurrentType[CurrentType["AC"] = 1] = "AC";
    /**
     * @generated from protobuf enum value: CURRENT_TYPE_DC = 2;
     */
    CurrentType[CurrentType["DC"] = 2] = "DC";
})(CurrentType || (CurrentType = {}));
/**
 * @generated from protobuf enum devices.v1.ConnectorType
 */
export var ConnectorType;
(function (ConnectorType) {
    /**
     * @generated from protobuf enum value: CONNECTOR_TYPE_UNSPECIFIED = 0;
     */
    ConnectorType[ConnectorType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * formerly TYPE_1
     *
     * @generated from protobuf enum value: CONNECTOR_TYPE_J1772_TYPE_1_INLET = 1;
     */
    ConnectorType[ConnectorType["J1772_TYPE_1_INLET"] = 1] = "J1772_TYPE_1_INLET";
    /**
     * formerly TYPE_2
     *
     * @generated from protobuf enum value: CONNECTOR_TYPE_J3068_TYPE_2_INLET = 2;
     */
    ConnectorType[ConnectorType["J3068_TYPE_2_INLET"] = 2] = "J3068_TYPE_2_INLET";
    /**
     * formerly CCS_1
     *
     * @generated from protobuf enum value: CONNECTOR_TYPE_CCS1_INLET = 3;
     */
    ConnectorType[ConnectorType["CCS1_INLET"] = 3] = "CCS1_INLET";
    /**
     * formerly CCS_2
     *
     * @generated from protobuf enum value: CONNECTOR_TYPE_CCS2_INLET = 4;
     */
    ConnectorType[ConnectorType["CCS2_INLET"] = 4] = "CCS2_INLET";
    /**
     * formerly CHADEMO
     *
     * @generated from protobuf enum value: CONNECTOR_TYPE_CHADEMO_INLET = 5;
     */
    ConnectorType[ConnectorType["CHADEMO_INLET"] = 5] = "CHADEMO_INLET";
    /**
     * formerly GBT_DC
     *
     * @generated from protobuf enum value: CONNECTOR_TYPE_GBT_DC_INLET = 7;
     */
    ConnectorType[ConnectorType["GBT_DC_INLET"] = 7] = "GBT_DC_INLET";
    /**
     * @generated from protobuf enum value: CONNECTOR_TYPE_J3068_PLUG = 9;
     */
    ConnectorType[ConnectorType["J3068_PLUG"] = 9] = "J3068_PLUG";
    /**
     * @generated from protobuf enum value: CONNECTOR_TYPE_J3400_INLET = 10;
     */
    ConnectorType[ConnectorType["J3400_INLET"] = 10] = "J3400_INLET";
    /**
     * @generated from protobuf enum value: CONNECTOR_TYPE_GBT_INLET = 11;
     */
    ConnectorType[ConnectorType["GBT_INLET"] = 11] = "GBT_INLET";
})(ConnectorType || (ConnectorType = {}));
/**
 * Canonical ESS status mirrored by the api-optimizer StrEnum and used by the
 * telemetry metric `ess_status` (value_string == enum name). Values intentionally
 * keep the FE1 `ESS_*` names (not `ESS_STATUS_*`) for parity with the optimizer
 * and Grafana dashboards, so ENUM_VALUE_PREFIX is suppressed per value below.
 *
 * @generated from protobuf enum devices.v1.EssStatus
 */
export var EssStatus;
(function (EssStatus) {
    /**
     * @generated from protobuf enum value: ESS_STATUS_UNSPECIFIED = 0;
     */
    EssStatus[EssStatus["ESS_STATUS_UNSPECIFIED"] = 0] = "ESS_STATUS_UNSPECIFIED";
    /**
     * buf:lint:ignore ENUM_VALUE_PREFIX
     *
     * @generated from protobuf enum value: ESS_OFFLINE = 1;
     */
    EssStatus[EssStatus["ESS_OFFLINE"] = 1] = "ESS_OFFLINE";
    /**
     * buf:lint:ignore ENUM_VALUE_PREFIX
     *
     * @generated from protobuf enum value: ESS_MAINTENANCE = 2;
     */
    EssStatus[EssStatus["ESS_MAINTENANCE"] = 2] = "ESS_MAINTENANCE";
    /**
     * buf:lint:ignore ENUM_VALUE_PREFIX
     *
     * @generated from protobuf enum value: ESS_FAULT = 3;
     */
    EssStatus[EssStatus["ESS_FAULT"] = 3] = "ESS_FAULT";
    /**
     * buf:lint:ignore ENUM_VALUE_PREFIX
     *
     * @generated from protobuf enum value: ESS_DISABLED = 4;
     */
    EssStatus[EssStatus["ESS_DISABLED"] = 4] = "ESS_DISABLED";
    /**
     * buf:lint:ignore ENUM_VALUE_PREFIX
     *
     * @generated from protobuf enum value: ESS_STORAGE_UNAVAILABLE = 5;
     */
    EssStatus[EssStatus["ESS_STORAGE_UNAVAILABLE"] = 5] = "ESS_STORAGE_UNAVAILABLE";
    /**
     * buf:lint:ignore ENUM_VALUE_PREFIX
     *
     * @generated from protobuf enum value: ESS_LOCKED = 6;
     */
    EssStatus[EssStatus["ESS_LOCKED"] = 6] = "ESS_LOCKED";
    /**
     * buf:lint:ignore ENUM_VALUE_PREFIX
     *
     * @generated from protobuf enum value: ESS_LOCKED_TIMEOUT = 7;
     */
    EssStatus[EssStatus["ESS_LOCKED_TIMEOUT"] = 7] = "ESS_LOCKED_TIMEOUT";
    /**
     * buf:lint:ignore ENUM_VALUE_PREFIX
     *
     * @generated from protobuf enum value: ESS_DISPATCH = 8;
     */
    EssStatus[EssStatus["ESS_DISPATCH"] = 8] = "ESS_DISPATCH";
    /**
     * buf:lint:ignore ENUM_VALUE_PREFIX
     *
     * @generated from protobuf enum value: ESS_DISPATCH_LOCAL = 9;
     */
    EssStatus[EssStatus["ESS_DISPATCH_LOCAL"] = 9] = "ESS_DISPATCH_LOCAL";
})(EssStatus || (EssStatus = {}));
/**
 * Sorting options
 *
 * @generated from protobuf enum devices.v1.SortDirection
 */
export var SortDirection;
(function (SortDirection) {
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_UNSPECIFIED = 0;
     */
    SortDirection[SortDirection["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_ASC = 1;
     */
    SortDirection[SortDirection["ASC"] = 1] = "ASC";
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_DESC = 2;
     */
    SortDirection[SortDirection["DESC"] = 2] = "DESC";
})(SortDirection || (SortDirection = {}));
// @generated message type with reflection information, may provide speed optimized methods
class Location$Type extends MessageType {
    constructor() {
        super("devices.v1.Location", [
            { no: 1, name: "latitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "longitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.latitude = 0;
        message.longitude = 0;
        message.address = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double latitude */ 1:
                    message.latitude = reader.double();
                    break;
                case /* double longitude */ 2:
                    message.longitude = reader.double();
                    break;
                case /* string address */ 3:
                    message.address = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* double latitude = 1; */
        if (message.latitude !== 0)
            writer.tag(1, WireType.Bit64).double(message.latitude);
        /* double longitude = 2; */
        if (message.longitude !== 0)
            writer.tag(2, WireType.Bit64).double(message.longitude);
        /* string address = 3; */
        if (message.address !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.address);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.Location
 */
export const Location = new Location$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PowerSpecification$Type extends MessageType {
    constructor() {
        super("devices.v1.PowerSpecification", [
            { no: 5, name: "max_charge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "max_discharge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "min_charge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "min_discharge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.maxChargePower = 0n;
        message.maxDischargePower = 0n;
        message.minChargePower = 0n;
        message.minDischargePower = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 max_charge_power */ 5:
                    message.maxChargePower = reader.int64().toBigInt();
                    break;
                case /* int64 max_discharge_power */ 6:
                    message.maxDischargePower = reader.int64().toBigInt();
                    break;
                case /* int64 min_charge_power */ 7:
                    message.minChargePower = reader.int64().toBigInt();
                    break;
                case /* int64 min_discharge_power */ 8:
                    message.minDischargePower = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 max_charge_power = 5; */
        if (message.maxChargePower !== 0n)
            writer.tag(5, WireType.Varint).int64(message.maxChargePower);
        /* int64 max_discharge_power = 6; */
        if (message.maxDischargePower !== 0n)
            writer.tag(6, WireType.Varint).int64(message.maxDischargePower);
        /* int64 min_charge_power = 7; */
        if (message.minChargePower !== 0n)
            writer.tag(7, WireType.Varint).int64(message.minChargePower);
        /* int64 min_discharge_power = 8; */
        if (message.minDischargePower !== 0n)
            writer.tag(8, WireType.Varint).int64(message.minDischargePower);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.PowerSpecification
 */
export const PowerSpecification = new PowerSpecification$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Timestamps$Type extends MessageType {
    constructor() {
        super("devices.v1.Timestamps", [
            { no: 1, name: "created_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "updated_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "deleted_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.createdAt = 0n;
        message.updatedAt = 0n;
        message.deletedAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 created_at */ 1:
                    message.createdAt = reader.int64().toBigInt();
                    break;
                case /* int64 updated_at */ 2:
                    message.updatedAt = reader.int64().toBigInt();
                    break;
                case /* int64 deleted_at */ 3:
                    message.deletedAt = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 created_at = 1; */
        if (message.createdAt !== 0n)
            writer.tag(1, WireType.Varint).int64(message.createdAt);
        /* int64 updated_at = 2; */
        if (message.updatedAt !== 0n)
            writer.tag(2, WireType.Varint).int64(message.updatedAt);
        /* int64 deleted_at = 3; */
        if (message.deletedAt !== 0n)
            writer.tag(3, WireType.Varint).int64(message.deletedAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.Timestamps
 */
export const Timestamps = new Timestamps$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HydrationOptions$Type extends MessageType {
    constructor() {
        super("devices.v1.HydrationOptions", [
            { no: 1, name: "include_device", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "include_station", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "include_evse", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "include_connector", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "include_models", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "include_errors", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.includeDevice = false;
        message.includeStation = false;
        message.includeEvse = false;
        message.includeConnector = false;
        message.includeModels = false;
        message.includeErrors = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool include_device */ 1:
                    message.includeDevice = reader.bool();
                    break;
                case /* bool include_station */ 2:
                    message.includeStation = reader.bool();
                    break;
                case /* bool include_evse */ 3:
                    message.includeEvse = reader.bool();
                    break;
                case /* bool include_connector */ 4:
                    message.includeConnector = reader.bool();
                    break;
                case /* bool include_models */ 5:
                    message.includeModels = reader.bool();
                    break;
                case /* bool include_errors */ 7:
                    message.includeErrors = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool include_device = 1; */
        if (message.includeDevice !== false)
            writer.tag(1, WireType.Varint).bool(message.includeDevice);
        /* bool include_station = 2; */
        if (message.includeStation !== false)
            writer.tag(2, WireType.Varint).bool(message.includeStation);
        /* bool include_evse = 3; */
        if (message.includeEvse !== false)
            writer.tag(3, WireType.Varint).bool(message.includeEvse);
        /* bool include_connector = 4; */
        if (message.includeConnector !== false)
            writer.tag(4, WireType.Varint).bool(message.includeConnector);
        /* bool include_models = 5; */
        if (message.includeModels !== false)
            writer.tag(5, WireType.Varint).bool(message.includeModels);
        /* bool include_errors = 7; */
        if (message.includeErrors !== false)
            writer.tag(7, WireType.Varint).bool(message.includeErrors);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.HydrationOptions
 */
export const HydrationOptions = new HydrationOptions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeviceFilter$Type extends MessageType {
    constructor() {
        super("devices.v1.DeviceFilter", [
            { no: 1, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["devices.v1.DeviceType", DeviceType, "DEVICE_TYPE_"] },
            { no: 2, name: "names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "serial_numbers", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "external_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "include_deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "created_after", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "created_before", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "customer_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.types = [];
        message.names = [];
        message.serialNumbers = [];
        message.externalIds = [];
        message.includeDeleted = false;
        message.createdAfter = 0n;
        message.createdBefore = 0n;
        message.customerIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated devices.v1.DeviceType types */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.types.push(reader.int32());
                    else
                        message.types.push(reader.int32());
                    break;
                case /* repeated string names */ 2:
                    message.names.push(reader.string());
                    break;
                case /* repeated string serial_numbers */ 3:
                    message.serialNumbers.push(reader.string());
                    break;
                case /* repeated string external_ids */ 4:
                    message.externalIds.push(reader.string());
                    break;
                case /* bool include_deleted */ 5:
                    message.includeDeleted = reader.bool();
                    break;
                case /* int64 created_after */ 6:
                    message.createdAfter = reader.int64().toBigInt();
                    break;
                case /* int64 created_before */ 7:
                    message.createdBefore = reader.int64().toBigInt();
                    break;
                case /* repeated string customer_ids */ 8:
                    message.customerIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated devices.v1.DeviceType types = 1; */
        if (message.types.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.types.length; i++)
                writer.int32(message.types[i]);
            writer.join();
        }
        /* repeated string names = 2; */
        for (let i = 0; i < message.names.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.names[i]);
        /* repeated string serial_numbers = 3; */
        for (let i = 0; i < message.serialNumbers.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.serialNumbers[i]);
        /* repeated string external_ids = 4; */
        for (let i = 0; i < message.externalIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.externalIds[i]);
        /* bool include_deleted = 5; */
        if (message.includeDeleted !== false)
            writer.tag(5, WireType.Varint).bool(message.includeDeleted);
        /* int64 created_after = 6; */
        if (message.createdAfter !== 0n)
            writer.tag(6, WireType.Varint).int64(message.createdAfter);
        /* int64 created_before = 7; */
        if (message.createdBefore !== 0n)
            writer.tag(7, WireType.Varint).int64(message.createdBefore);
        /* repeated string customer_ids = 8; */
        for (let i = 0; i < message.customerIds.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.customerIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeviceFilter
 */
export const DeviceFilter = new DeviceFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocationFilter$Type extends MessageType {
    constructor() {
        super("devices.v1.LocationFilter", [
            { no: 1, name: "center_latitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "center_longitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "radius_km", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.centerLatitude = 0;
        message.centerLongitude = 0;
        message.radiusKm = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double center_latitude */ 1:
                    message.centerLatitude = reader.double();
                    break;
                case /* double center_longitude */ 2:
                    message.centerLongitude = reader.double();
                    break;
                case /* double radius_km */ 3:
                    message.radiusKm = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* double center_latitude = 1; */
        if (message.centerLatitude !== 0)
            writer.tag(1, WireType.Bit64).double(message.centerLatitude);
        /* double center_longitude = 2; */
        if (message.centerLongitude !== 0)
            writer.tag(2, WireType.Bit64).double(message.centerLongitude);
        /* double radius_km = 3; */
        if (message.radiusKm !== 0)
            writer.tag(3, WireType.Bit64).double(message.radiusKm);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.LocationFilter
 */
export const LocationFilter = new LocationFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SortOptions$Type extends MessageType {
    constructor() {
        super("devices.v1.SortOptions", [
            { no: 1, name: "field", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "direction", kind: "enum", T: () => ["devices.v1.SortDirection", SortDirection, "SORT_DIRECTION_"] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.field = "";
        message.direction = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string field */ 1:
                    message.field = reader.string();
                    break;
                case /* devices.v1.SortDirection direction */ 2:
                    message.direction = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string field = 1; */
        if (message.field !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.field);
        /* devices.v1.SortDirection direction = 2; */
        if (message.direction !== 0)
            writer.tag(2, WireType.Varint).int32(message.direction);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.SortOptions
 */
export const SortOptions = new SortOptions$Type();
//# sourceMappingURL=common.js.map